import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ValuableProductCategory } from 'src/app/models/virtual-store/valuable-product-category.model';
import { Subscription } from 'rxjs';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { Account } from 'src/app/models/account.model';
import { ProductCategory } from 'src/app/models/virtual-store/product-category.model';
import { DetailedOrderItem } from 'src/app/models/virtual-store/detailed-order-item.model';
import { MatDialog } from '@angular/material/dialog';
import { VirtualStoreDniValidatorComponent } from '../virtual-store-dni-validator/virtual-store-dni-validator.component';
import { OrderItemService } from 'src/app/services/order-item.service';
import { CommonService } from 'src/app/services/common.service';
import { OrderItemUpdateRequest } from 'src/app/models/virtual-store/order-item-update-request.model';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppConstant } from 'src/app/constants/app.constant';
import { EnvironmentService } from 'src/app/core/services/environment.service';
declare var fbq: Function;
@Component({
  selector: 'order-validation',
  templateUrl: './order-validation.component.html',
  styleUrls: ['./order-validation.component.scss']
})
export class OrderValidationComponent implements OnInit {
  @Output() stepCompleted = new EventEmitter();
  orderItemList: DetailedOrderItem[] = [];
  /*Número de cuotas seleccionada */
  selectedMonthlyPaymentMode: number = 0;
  /*Lista de categorías incluidas en el pedido */
  valuableCategoryList: ValuableProductCategory[] = [];
  selectedMonthlyPaymentModeList: number[] = [];
  totalDiscount: number = 0;
  totalAmount: number = 0;
  /*Subscripción a observable de pedido actualizado */
  orderUpdatedSubscription: Subscription;
  account: Account;
  /*Suscripción a observable de linea de crédito actualizada */
  accountSelectedSubscription: Subscription;
  isFnb: boolean = false;
  codeFilterFnb: string = AppConstant.FNB;
  constructor(
    private virtualStoreService: VirtualStoreService,
    public dialog: MatDialog,
    private orderItemService: OrderItemService,
    private commonService: CommonService,
    private authService: AuthService,
    private environmentService: EnvironmentService
  ) {
    this.orderUpdatedSubscription = this.virtualStoreService.orderUpdatedAnnounced.subscribe(orderItemList => {
      this.orderItemList = orderItemList;
      this.orderUpdated();
    })
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.account = account;
      this.isFnb = this.authService.getCreditLineFNB().isCreditLineFNB;
    });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.orderUpdatedSubscription.unsubscribe();
    this.accountSelectedSubscription.unsubscribe();
  }
  orderUpdated() {
    this.updateMonthlyPaymentModeList();
    this.updateCategoryList();
    this.updateTotalDiscount();
    this.updateTotalAmount();
  }
  loadOrderItems() {
    let isFnb = this.authService.getCreditLineFNB().isCreditLineFNB;
    this.orderItemService.listPendingOnes(this.account.clientCode, isFnb).subscribe(
      response => {
        if (response.valid) { this.orderItemList = response.data; }
      }
    )
  }
  updateCategoryList() {
    this.valuableCategoryList = this.orderItemList.map(item => new ValuableProductCategory(item.product.category));
    this.valuableCategoryList = Array.from(new Set(this.valuableCategoryList.map(s => JSON.stringify(s)))).map(item => JSON.parse(item));
    this.updateCategoryListAmounts();
  }
  updateCategoryListAmounts() {
    this.valuableCategoryList.map(valuableCategory => {
      valuableCategory.amount = this.getTotalAmountByCategory(valuableCategory.category);
      return valuableCategory;
    });
  }
  getTotalAmountByCategory(category: ProductCategory) {
    if (this.orderItemList != null && this.orderItemList.length > 0) {
      return this.orderItemList.filter(x => x.product.category.code === category.code).map(x => x.product.price * x.count).reduce(function (previous, current) {
        return previous + current;
      });
    } else { return 0; }
  }
  updateMonthlyPaymentModeList() {
    const list = this.orderItemList.map(item => item.product.monthlyPaymentModeList.map(mode => mode.monthCount));
    if (list.length == 1) {
      this.selectedMonthlyPaymentModeList = list[0];
    } else if (list.length > 0) {
      for (let i = 0; i < list.length - 1; i++) {
        list[i + 1] = list[i].filter(x => list[i + 1].some(y => y === x));
        if (i === list.length - 2) {
          this.selectedMonthlyPaymentModeList = list[i + 1];
        }
      }
    }
    this.selectedMonthlyPaymentMode = this.orderItemList.length > 0 ? this.orderItemList[0].monthlyPaymentCount : this.selectedMonthlyPaymentModeList[0];
  }
  getMonthlyPaymentAmount(orderItem: DetailedOrderItem, monthCount: number) {
    const monthlyPaymentMode = orderItem.product.monthlyPaymentModeList.find(x => x.monthCount === monthCount);
    if (monthlyPaymentMode) { return monthlyPaymentMode.amountPerMonth * orderItem.count; } else { return 0; }
  }
  getMainImage(orderItem: DetailedOrderItem) {
    if (orderItem.product.imageList && orderItem.product.imageList.filter(x => x.isMain).length > 0) {
      return orderItem.product.imageList.find(x => x.isMain).source;
    } else { return null; }
  }

  updateTotalDiscount() {
    this.totalDiscount = 0;
    if (this.orderItemList != null && this.orderItemList.length > 0) {
      this.totalDiscount = this.orderItemList.map(x => x.product.ofvDiscount * x.count).reduce((previous, current) => {
        return previous + current;
      });
    }
  }
  updateTotalAmount() {
    this.totalAmount = 0;
    if (this.orderItemList != null && this.orderItemList.length > 0) {
      this.totalAmount = this.orderItemList.map(x => (x.product.price - x.product.ofvDiscount) * x.count).reduce((previous, current) => {
        return previous + current;
      });
    }
  }
  getTotalMonthlyPaymentAmount(orderItemList: DetailedOrderItem[], selectedMonthlyPaymentMode: number) {
    if (orderItemList != null && orderItemList.length > 0) {
 
      return orderItemList.map(x => {

        const find = x.product.monthlyPaymentModeList.find(y => y.monthCount === selectedMonthlyPaymentMode);
        if (find)
          return find.amountPerMonth * x.count
        else
          return 0

      }
      )
        .reduce((previous, current) => previous + current);
    } else { return 0; }
  }
  removeOrderItem(item: DetailedOrderItem) {
    let isFnb = this.authService.getCreditLineFNB().isCreditLineFNB;
    this.orderItemService.removePendingOne(item.id, this.account.clientCode, isFnb).subscribe(response => {
      if (response.valid) {
        this.updateTotalAmount();
        this.updateTotalDiscount();
        this.updateCategoryList();

        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      }
    })
  }

  itemCountChanged($event: any, item: DetailedOrderItem) {
    const basicItem = new OrderItemUpdateRequest();
    basicItem.id = item.id;
    basicItem.clientCode = this.account.clientCode;
    basicItem.count = item.count;
    basicItem.monthlyPaymentCount = this.selectedMonthlyPaymentMode;
    basicItem.documentNumber = this.authService.getBasicData().documentNumber;
    basicItem.documentType = this.authService.getBasicData().documentType;
    basicItem.isFnb = this.authService.getCreditLineFNB().isCreditLineFNB;
    this.orderItemService.updatePendingOne(basicItem).subscribe(response => {
      if (response.valid) {
        this.updateCategoryListAmounts();
        this.updateTotalDiscount();
        this.updateTotalAmount();
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      } else if (!response.valid && response.warning) {
        item.count = $event.previousValue;
        Swal.fire('Información', response.message, 'warning')
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      } else {
        item.count = $event.previousValue;
      }
    })
  }
  validateBuyPermission() {
    let clienData = this.authService.getBasicData();
    if (clienData.documentType === AppConstant.documentTypeDNI) {
      this.virtualStoreService.canBuy(this.account.clientCode).subscribe(response => {
        localStorage.setItem('nroCuotas', this.selectedMonthlyPaymentMode.toString());
        console.log(this.selectedMonthlyPaymentMode);
        if (response.valid) this.openDniValidation();
      });
    } else {
      Swal.fire('Información', AppConstant.messageCannotBuy, 'warning')
    }
    fbq('track', 'InitiateCheckout');
  }
  openDniValidation() {
    const dialogRef = this.dialog.open(VirtualStoreDniValidatorComponent, {
      data: {
        clientCode: this.account.clientCode,
        orderItemList: this.orderItemList.map(item => {
          item.monthlyPaymentCount = this.selectedMonthlyPaymentMode
          return item;
        })
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response && response.proceed) { this.stepCompleted.emit({ dni: response.dni, fullName: response.fullName }); }
    });
  }
  public irACatalogo(): void {
    const token = this.authService.getAuthToken();
    location.href = this.environmentService.urlTiendaCatalogo + `?token=${token}`;
    return;
  }
}
